/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const FETCH_SCHOOL_DETAILS_SUCCESS = 'FETCH_SCHOOL_DETAILS_SUCCESS';

export function fetchSchoolDetailsSuccess(payload) {
    return {type: FETCH_SCHOOL_DETAILS_SUCCESS, payload: payload};
}

export const CLEAR_SCHOOL_DETAIL = 'CLEAR_SCHOOL_DETAIL';

export function clearSchoolDetail() {
    return {type: CLEAR_SCHOOL_DETAIL};
}

export const FETCH_CONTACT_DETAILS_SUCCESS = 'FETCH_CONTACT_DETAILS_SUCCESS';

export function fetchContactDetailsSuccess(payload) {
    return {type: FETCH_CONTACT_DETAILS_SUCCESS, payload: payload};
}

export const FETCH_SALES_FOCE_DETAILS_SUCCESS = 'FETCH_SALES_FOCE_DETAILS_SUCCESS';

export function fetchSalesForceDetailsSuccess(payload) {
    return {type: FETCH_SALES_FOCE_DETAILS_SUCCESS, payload: payload};
}

export const FETCH_CREATOR_DETAILS_SUCCESS = 'FETCH_CREATOR_DETAILS_SUCCESS';

export function fetchCreatorDetailsSuccess(payload) {
    return {type: FETCH_CREATOR_DETAILS_SUCCESS, payload: payload};
}

export const SET_ORG_UNIT = 'SET_ORG_UNIT';

export function setOrgUni(payload){
    return {type :  SET_ORG_UNIT,payload: payload};
}

export const SET_COURSE_NAME = 'SET_COURSE_NAME';

export function setCourseName(payload){
    return {type : SET_COURSE_NAME,payload: payload};
}

export const SET_COURSE_NO = 'SET_COURSE_NO';

export function setCourseNo(payload){
    return {type: SET_COURSE_NO, payload: payload};
}

export const SET_ESTIMATED_ENROLLMENTS = 'SET_ESTIMATED_ENROLLMENTS';

export function setEstimatedEnrollments(payload){
    return {type: SET_ESTIMATED_ENROLLMENTS, payload: payload};
}

export const SET_CLASS_START = 'SET_CLASS_START';

export function setClassStart(payload){
    return { type: SET_CLASS_START, payload: payload };
}

export const SET_END_START = 'SET_END_START';

export function setClassEnd(payload){
    return { type: SET_END_START, payload: payload };
}

export const SEARCH_SCHOOL_BY_POSTALCODE_SUCCESS = 'SEARCH_SCHOOL_BY_POSTALCODE_SUCCESS';

export function searchSchoolByPostalCodeSuccess(payload) {
    return { type: SEARCH_SCHOOL_BY_POSTALCODE_SUCCESS, payload };
}

export const RESET_SCHOOL_LIST = "RESET_SCHOOL_LIST";

export function resetSchoolList() {
    return { type: RESET_SCHOOL_LIST };
}


// WEBPACK FOOTER //
// ./src/_actions/order.details.actions.js